
import moment from 'moment';

import React, { Component } from 'react';
import { DateWidget } from 'form/new/DateWidget';

import CachedIcon from '@material-ui/icons/Cached';
import ClearIcon from '@material-ui/icons/Clear';
import {Button, IconButton} from '@material-ui/core';
import ArrowBackIosOutlinedIcon from "@material-ui/icons/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@material-ui/icons/ArrowForwardIosOutlined";


export class ScheduleListFilter extends Component {

  setToday = (context) => {
    context.setFilterValue('date', moment().format('YYYY-MM-DD'))
  };

  previousDay = (context) => {
    let dateStart = moment(context.filter.date);
    dateStart.subtract(1, 'd');
    context.setFilterDateValue('date', dateStart);
  };

  nextDay = (context) => {
    let dateStart = moment(context.filter.date);
    dateStart.add(1, 'd');
    context.setFilterDateValue('date', dateStart);
  };

  render() {
    const { context } = this.props;
    const { filter, loading, setFilterValue } = context;
    const hasDate = moment(filter.date || '').isValid();

    return (
      <>
        <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
          <IconButton size={'small'} disabled={!hasDate} onClick={() => this.previousDay(context)}>
            <ArrowBackIosOutlinedIcon/>
          </IconButton>
          <div className={'w-200'}>
            <DateWidget
              value={filter.date || null}
              onChange={(value, stringValue) => setFilterValue('date', stringValue)}
              size={'small'}
            />
          </div>
          <IconButton size={'small'} disabled={!hasDate} onClick={() => this.nextDay(context)}>
            <ArrowForwardIosOutlinedIcon/>
          </IconButton>
        </div>
        <Button
          onClick={() => this.setToday(context)}
          style={{fontWeight: 'normal'}}
          variant={'outlined'}
          disabled={filter.date === moment().format('YYYY-MM-DD')}
        >
          Сегодня
        </Button>
        <IconButton
          disabled={loading}
          variant="outlined"
          size={'small'}
          onClick={() => context.setPageNumber(1)}
        >
          <CachedIcon/>
        </IconButton>
        <IconButton
          disabled={loading}
          variant="outlined"
          size={'small'}
          onClick={() => context.setFilter({})}
        >
          <ClearIcon/>
        </IconButton>
      </>
    )
  }
}
